import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { type SplitSupplyNoticeSection } from '@ebalance/proto/bffuser/v1/split_supply_plan_model_pb'
import { getPartnerSplitSupplyNoticeFormOptions } from '@ebalance/proto/bffuser/v1/split_supply_plan_service-SplitSupplyPlanService_connectquery'
import {
  GetPartnerSplitSupplyNoticeFormOptionsRequestSchema,
  type GetPartnerSplitSupplyNoticeFormOptionsResponse,
} from '@ebalance/proto/bffuser/v1/split_supply_plan_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

import { type CivilDate, civilDateToProtoDate } from '~/models/civilDate'

type Params = {
  section: SplitSupplyNoticeSection
  /** 翌日の登録は受渡日、 月間の登録は対象月の 1 日。 受渡日 (月間は月初) で契約と自社の事業者を判定する。 */
  targetDate: CivilDate
  /** 追加のダイアログが開いている間だけ取得する。 */
  enabled: boolean
}

/**
 * 他社の通告値を追加する時に選べる他社の候補 (エリアごと) の取得 hook。
 * 他社が通告値を出す変動型の契約を持つエリアと、 その契約の他社だけが返る。
 */
export function useGetPartnerSplitSupplyNoticeFormOptions({
  section,
  targetDate,
  enabled,
}: Params): UseQueryResult<
  GetPartnerSplitSupplyNoticeFormOptionsResponse,
  ConnectError
> {
  return useQuery(
    getPartnerSplitSupplyNoticeFormOptions,
    create(GetPartnerSplitSupplyNoticeFormOptionsRequestSchema, {
      section,
      targetDate: civilDateToProtoDate(targetDate),
    }),
    // 失敗は追加のダイアログの中で案内する (画面全体のエラー境界へ伝播させない)
    { enabled, throwOnError: false },
  )
}
